import assignment_ind from '../../../assets/icons/accounts-icons/assignment_ind.png';
import FormAttributes from '../../workflow/arf_framework';
import './employee.css';
import { useNavigate } from 'react-router-dom';
import URLData from '../../../Data/URL-Data';
import { useTranslation } from 'react-i18next';

const ManageAccounts = () => {
    const navigate = useNavigate();
    const { t, i18n } = useTranslation();
    const updateProfile = () => {
        // navigate('/update-profile');
        URLData.OPEN_URL_CHECKER(
            "myidm",
            "profile_update"
          );
    }
    const updatePhone = () => {
        URLData.OPEN_URL_CHECKER(
            "myidm",
            "update_phone_email"
          );
        // navigate('/update-phone');
    }
    const changePassword = () => {
        navigate('/change-password');
    }
    const nonEmployeeExtension = () => {
        navigate('/extension-request');
    }

    return (
        <div id="mangeAccounts" >
            <div className='card accountCard'>
                <h3>{t("manageAccounts.manage_accounts")}</h3>
                <div className="accountContent card-content">
                    <div className='d-flex accountLayout'>
                        <div className="card accountReqCard">
                            <div className="card-content">
                                <div  className='quickLinks cursor-pointer' onClick={updateProfile} >
                                    <img src={assignment_ind} alt="Gpid" />
                                    <div className="cardLabel">{t("manageAccounts.update_profile")}</div>
                                    <div className="detailsValue">{t("manageAccounts.update_profile_desc")} </div>
                                </div>
                            </div>
                        </div>
                        {/* <div className="card accountReqCard">
                            <div className="card-content">
                                <div>
                                    <img src={assignment_ind} alt="Gpid" />
                                    <div className="cardLabel">Validate alternate email</div>
                                    <div className="detailsValue">I’m the description for this card</div>
                                </div>
                            </div>
                        </div> */}
                        <div className="card accountReqCard">
                            <div className="card-content">
                                <div className='quickLinks cursor-pointer' onClick={updatePhone}>
                                    <img src={assignment_ind} alt="Gpid" />
                                    <div className="cardLabel">{t("manageAccounts.update_personal_phone_email")}</div>
                                    <div className="detailsValue">{t("manageAccounts.update_personal_phone_email_desc")}</div>
                                </div>
                            </div>
                        </div>
                        {/* <div className="card accountReqCard">
                            <div className="card-content">
                                <div>
                                    <img src={assignment_ind} alt="Gpid" onClick={nonEmployeeExtension} />
                                    <div className="cardLabel">Non-employee extension for self</div>
                                    <div className="detailsValue">I’m the description for this card</div>
                                </div>
                            </div>
                        </div> */}
                        {/* <div className="card accountReqCard">
                            <div className="card-content">
                                <div   className='quickLinks cursor-pointer' onClick={changePassword}>
                                    <img src={assignment_ind} alt="Gpid" />
                                    <div className="cardLabel">Change password</div>
                                    <div className="detailsValue">I’m the description for this card</div>
                                </div>
                            </div>
                        </div> */}
                        {/* <div className="card accountReqCard">
                            <div className="card-content">
                                <div>
                                    <img src={assignment_ind} alt="Gpid" />
                                    <div className="cardLabel">Mobile change password</div>
                                    <div className="detailsValue">I’m the description for this card</div>
                                </div>
                            </div>
                        </div>                         */}
                        {/* <div className="card accountReqCard">
                            <div className="card-content">
                                <div>
                                    <img src={assignment_ind} alt="Gpid" />
                                    <div className="cardLabel">Change security Q & A</div>
                                    <div className="detailsValue">I’m the description for this card</div>
                                </div>
                            </div>
                        </div> */}
                        {/* <div className="card accountReqCard">
                            <div className="card-content">
                                <div>
                                    <img src={assignment_ind} alt="Gpid" />
                                    <div className="cardLabel">Update security PIN</div>
                                    <div className="detailsValue">I’m the description for this card</div>
                                </div>
                            </div>
                        </div> */}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ManageAccounts;